var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "26px",
    viewBox: "0 0 15 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "np_caret-down_1916333_000000 copy 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Booking-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Booking-Page---5-Confirmation(v2)",
    transform: "translate(-1151.000000, -1071.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(242.000000, 1049.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_caret-down_1916333_000000-copy-6",
    transform: "translate(916.500000, 35.000000) scale(-1, -1) rotate(90.000000) translate(-916.500000, -35.000000) translate(904.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4980797,14 C12.0239121,14 11.5698608,13.8161491 11.2347909,13.4861841 L0.5118701,2.9804212 C-0.1750831,2.29590771 -0.170021881,1.1960804 0.523597973,0.516483605 C1.21724228,-0.163113189 2.33980341,-0.168029886 3.03846604,0.504993242 L12.4982268,9.77317731 L21.9579875,0.504993242 C22.6566502,-0.171325754 23.7825569,-0.168047956 24.4762012,0.513200764 C25.1715182,1.19279756 25.1748638,2.29590267 24.4845783,2.98041616 L13.7616575,13.4861791 C13.4265662,13.8161273 12.9725363,13.999995 12.4983688,13.999995 L12.4980797,14 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.c9454b88e0916b46529b30927d942d60.svg";
export { ForwardRef as ReactComponent };